import React from 'react';
import PhoneInput from 'react-phone-input-2';
//import 'react-phone-input-2/lib/style.css';
import 'react-phone-input-2/lib/bootstrap.css';

const CountryCodeSelect = ({ value, onChange, placeholder = "Select country code" }) => {
  return (
    <PhoneInput
      country={'ng'} // Default country
      value={value}
      onChange={onChange}
      inputProps={{
        name: 'phone',
        required: true,
        autoFocus: false
      }}
      containerClass=""
      inputClass="form-control"
      inputStyle={{ width: '100%', fontSize: '1rem', height: '3rem' }}
      buttonClass="phone-input-button"  
      dropdownClass="phone-input-dropdown"
      placeholder={placeholder}
      enableSearch={true}
      disableSearchIcon={true}
      countryCodeEditable={false}
      preferredCountries={['ng', 'us', 'gb', 'in', 'cn', 'de', 'fr', 'br', 'au', 'za', 'ke', 'gh']}
      enableAreaCodes={false}
      disableCountryCode={false}
      onlyCountries={[]} // Empty array = all countries
    />
  );
};

export default CountryCodeSelect;